import { NotificationClientService, NotificationType } from './../../../../../services/basics/notification-client.service';
import { autoinject, transient } from "aurelia-framework";
import { RightShipDialogServiceConstants } from "../../../../../constants/basics/rightship-dialog.constants";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { VesselDetailModel } from "../../../../../models/vessels/vessel.models";
import { AddSubtaskRequest, EmailRecipientTypeEnum, SubtaskCorrespondenceEmailModel } from "../../../../../models/vetting/vetting.models";
import { UserClientService } from "../../../../../services/authentication/user-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { CustomerService } from "../../../../../services/modules/customer-client.service";
import { SubtasksService } from "../../../../../services/subtasks/subtasks.service";
import { RightshipEntityAttachmentManager } from "../../common-steps/rightship-entity-attachment/rightship-entity-attachment-manager";
import { AttachmentFile } from '../../../../../models/uploader/attachmentFile';
import { Guid } from '../../../../../utilities/guid';

@autoinject
@transient()
export class RequestSafetyScoreReviewDialog {
    accept: string = "application/pdf,image/png,image/jpeg,image/jpg,application/zip,application/x-zip-compressed,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/vnd.ms-outlook,.msg";

    isHostedCustomer: boolean = false;
    requestSubmitted: boolean = false;
    vessel: VesselDetailModel = null;
    documentOfComplianceEmail: string = null;
    message: string = "";
    vetRequiresMoreInformationEmails: SubtaskCorrespondenceEmailModel[] = [];
    onConfirm: () => void;

    constructor(private dialogClientService: DialogClientService, customerService: CustomerService, private subtaskService: SubtasksService,
        public attachmentDialogBroker: RightshipEntityAttachmentManager, private userClientService: UserClientService,
        private notificationClientService: NotificationClientService) {
        this.attachmentDialogBroker.accept = this.accept;
        customerService.isHostedCustomer()
            .then(x => { this.isHostedCustomer = x; })
            .catch(e => {
                this.isHostedCustomer = false;
                console.warn(e);
            });
    }

    subtaskCorrespondenceId: number;

    public addAttachment() {
        this.attachmentDialogBroker.rootItem = {
            entityType: EntityTypes.SubtaskCorrespondence,
            identifier: Guid.generateGuid()
        };
        this.attachmentDialogBroker.rootItem["id"] = this.subtaskCorrespondenceId;
        this.attachmentDialogBroker.saveFunc = async () => {
            await this.addSubtask(false);
            this.attachmentDialogBroker.rootItem["id"] = this.subtaskCorrespondenceId;
            return () => {
            };
        };
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.RightshipAttachmentsDialog, this.attachmentDialogBroker, true, false, false, 'right');
    }

    entityId: number;
    attachments: File[] = [];
    public files: AttachmentFile[] = [];

    private async addSubtask(submit: boolean) {
        const request: AddSubtaskRequest = {
            entityId: this.entityId,
            entityTypeId: EntityTypes.SafetyRatingReview,
            subtaskId: null,
            isInternal: false,
            skipInvitation: true,
            changeStatusToAwaitingResponse: false,
            emails: [{
                email: this.userClientService.currentUser.email,
                emailRecipientTypeId: EmailRecipientTypeEnum.To
            }],
            message: this.message,
            resendEmail: false,
            name: `Review Request Correspondence`,
            statusSnippet: "Review Request Correspondence",
            comment: "",
            submit: submit,
            subtaskTypes: [],
            subtaskCorrespondenceId: this.subtaskCorrespondenceId,
            linkedEntityIds: [],
            linkedEntityTypeId: null,
            attachments: submit ? this.attachments : [],
            files: submit ? this.files : [],
            isCustomerRFI: true,
            dataSourceId: 0
        };
        if (this.entityId)
            this.subtaskCorrespondenceId = await this.subtaskService.addSubtask(request);
    }

    activate(data: { entityId: number, vetRequiresMoreInformationEmails: SubtaskCorrespondenceEmailModel[], vessel: VesselDetailModel, onConfirm: () => void }) {
        this.entityId = data.entityId;
        this.vessel = data.vessel;
        this.onConfirm = data.onConfirm;
        // this.documentOfComplianceEmail = data.vessel.documentOfComplianceEmail;
        this.vetRequiresMoreInformationEmails = data.vetRequiresMoreInformationEmails;
    }

    async submit() {
        try {
            await this.addSubtask(true);
            this.dialogClientService.hide();
            this.notificationClientService.show("Request for Safety Score Rule review submitted successfully", "Thank you for your request. You will receive an email when RightShip respond back to you.", NotificationType.Success)
        } catch (e) {
            console.error("Failed to submit subtask", e);
        }
    }

    close() {
        this.dialogClientService.hide();
    }
}